import { optionsToStrategy } from "@/common/utils/optionsToStrategy"

export const tmaisRafflesStatusOptions = [
  {label: 'Ativo', value: 'active'},
  {label: 'Inativo', value: 'disabled'},
  {label: 'Completado', value: 'completed'},
  {label: 'Vencedor selecionado', value: 'winner_selected'}
]

export const tmaisRafflesStatusStrategy = optionsToStrategy(tmaisRafflesStatusOptions)